export default "__VITE_ASSET__C6hg$VKM__"